import React, { useEffect, useState } from 'react';
import { Sparkles } from 'lucide-react';
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from '@/components/ui/tabs';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { Label } from '@/components/ui/label';
import { useLocations } from '@/hooks/useApi';
import { ShiftsTab } from '@/components/optimization/ShiftsTab';
import { MinStaffingTab } from '@/components/optimization/MinStaffingTab';
import { LaborRulesTab } from '@/components/optimization/LaborRulesTab';
import { ConfigTab } from '@/components/optimization/ConfigTab';
import { RunsHistoryTab } from '@/components/optimization/RunsHistoryTab';

export const SmartScheduleSettings: React.FC = () => {
  const { data: locationsResp } = useLocations({ limit: 200 });
  const locations: Array<{ id: string; name: string }> =
    (locationsResp as { data?: Array<{ id: string; name: string }> })?.data ??
    [];

  const [locationId, setLocationId] = useState<string>('');
  const [activeTab, setActiveTab] = useState('shifts');

  // Auto-select first location if none picked yet
  useEffect(() => {
    if (!locationId && locations.length > 0) {
      setLocationId(locations[0].id);
    }
  }, [locations, locationId]);

  return (
    <div className="flex-1 min-h-0 overflow-y-auto p-6 space-y-4 max-w-6xl">
      <div className="flex items-center gap-2">
        <Sparkles className="h-6 w-6 text-purple-600" />
        <h1 className="text-2xl font-bold">Smart Schedule — настройки</h1>
      </div>
      <p className="text-sm text-muted-foreground">
        Параметры автоматической генерации графиков: смены, трудовые правила
        по должностям и веса целевой функции solver-а.
      </p>

      <div className="max-w-md">
        <Label>Локация</Label>
        <Select value={locationId} onValueChange={setLocationId}>
          <SelectTrigger>
            <SelectValue placeholder="Выберите локацию" />
          </SelectTrigger>
          <SelectContent>
            {locations.map((l) => (
              <SelectItem key={l.id} value={l.id}>
                {l.name}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      <Tabs value={activeTab} onValueChange={setActiveTab}>
        <TabsList>
          <TabsTrigger value="shifts">Смены</TabsTrigger>
          <TabsTrigger value="min-staffing">Минимальный штат</TabsTrigger>
          <TabsTrigger value="rules">Трудовые правила</TabsTrigger>
          <TabsTrigger value="config">Веса и solver</TabsTrigger>
          <TabsTrigger value="runs">История запусков</TabsTrigger>
        </TabsList>

        <TabsContent value="shifts" className="mt-4">
          <ShiftsTab locationId={locationId || null} />
        </TabsContent>

        <TabsContent value="min-staffing" className="mt-4">
          <MinStaffingTab locationId={locationId || null} />
        </TabsContent>

        <TabsContent value="rules" className="mt-4">
          <LaborRulesTab />
        </TabsContent>

        <TabsContent value="config" className="mt-4">
          <ConfigTab locationId={locationId || null} />
        </TabsContent>

        <TabsContent value="runs" className="mt-4">
          <RunsHistoryTab locationId={locationId || null} />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default SmartScheduleSettings;
